//#region src/variants/variants_banner.js
var variants_banner_default = { default: {
	slots: { default: { initialValue: "Message body with <a href=\"#\" class=\"d-link d-link--muted\">a link</a>." } },
	props: {
		headerText: { initialValue: "Example banner" },
		kind: { initialValue: "info" }
	}
} };
//#endregion
export { variants_banner_default as default };

//# sourceMappingURL=variants_banner.js.map